import * as bootstrap from "bootstrap";

import Choices from "choices.js";
import flatpickr from "flatpickr";

import "./admin";
import "./cable";

document.addEventListener("DOMContentLoaded", () => {
  const select = document.getElementById("search_by_state");
  if (select) {
    new Choices(select, {
      removeItemButton: true,
      placeholderValue: "Select states",
    });
  }

  const datepickers = document.querySelectorAll(".datepicker");
  datepickers.forEach(el => {
    flatpickr(el, {
      dateFormat: "d/m/Y",
    });
  });
});
